import React, { useEffect, useState } from 'react'
import Config from '../Config';
import Cookies from 'js-cookie';
import { useAuthHandling } from '../useAuthhandling';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../Sidebar';
import Navbar from '../Navbar';

function Bannerview() {
    const { isAuthorized, handleUnauthorized } = useAuthHandling();
    let navigate = useNavigate();
    let { id } = useParams();
    const tokens = Cookies.get("a_token");
    if (!tokens) {
        navigate("/");
    }
    const [banner, setBanner] = useState([]);


    const getinfo = async (e) => {
        const res = await fetch(`${Config.apiurl}/api/v1/crm/banner/get-banner/${id}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
        });
        if (res.status === 200) {
            const data = await res.json();
            setBanner(data.data);
        }
        else if (res.status === 401) {
            handleUnauthorized();
            getinfo();
        }
        else {
            console.log("error");
        }
    };


    useEffect(() => {
        getinfo();
    }, [])
    return (
        <div className="container-scroller">
            <Navbar />

            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className='view_page_top'>
                            <Link to="/bannerlist">Banner list</Link>
                            <Link to={"/editbanner/" + id}>Edit</Link>
                        </div>
                        <div className="row">
                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Banner View page</h4>

                                        <div className='row view_div_row'>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6>Title </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p> {banner.title}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-6'>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Type </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {banner.fileType}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Status </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {banner.status === true ? 'True' : "False"}</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className='col-12 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> File </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        {banner.fileType === 'image' ?
                                                            <img src={banner.fileUploadPath} style={{ width: "100px", height: "100px", marginTop: "10px" }} />
                                                            :
                                                            <video
                                                                className="video-slide active"
                                                                src={banner.fileUploadPath}
                                                                autoPlay
                                                                muted
                                                                loop
                                                                width="100"
                                                                height="100"
                                                            ></video>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div className='row view_div_row'>
                            <div className='col-6 col-md-2'>
                                Title :
                            </div>
                            <div className='col-6 col-md-10'>
                           { banner.title}
                            </div>
                            <div className='col-6 col-md-2'>
                                Type :
                            </div>
                            <div className='col-6 col-md-10'>
                           { banner.fileType}
                            </div>
                            <div className='col-6 col-md-2'>
                                File :
                            </div>
                            <div className='col-6 col-md-10'>
                            {banner.fileType==='image'?
                        <img src={banner.fileUploadPath} style={{width:"100px",height:"100px",marginTop:"10px"}}/>
                        :
                        <video
                        className="video-slide active"
                        src={banner.fileUploadPath}
                        autoPlay
                        muted
                        loop
                        width="100"
                        height="100"
                      ></video>   
  }
                            </div>
                            <div className='col-6 col-md-2'>
                                Status :
                            </div>
                            <div className='col-6 col-md-10'>
                           {banner.status===true?'True':"False"}
                            </div>
                                                </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Bannerview
